import { useMutation } from '@tanstack/react-query';
import { CrewMerchantUi } from 'corso-types';
import api from '~/api';
import { useRegistration } from '~/features/registrationReview/RegistrationReviewProvider';
import { Timeline } from '~/features/timeline/Timeline';
import { useStoreId } from '~/providers/StoreUserProvider';

export function RegistrationTimeline() {
  const storeId = useStoreId();

  const { id, timeline: events = [], refetch } = useRegistration();

  const { mutateAsync: addTimelineEvent, isPending } = useMutation({
    mutationFn: (body: CrewMerchantUi.TimelineEvent) =>
      api.store(storeId).registrations.addTimelineEvent({
        registrationId: `${id}`,
        body,
      }),
    onSuccess: () => refetch(),
  });

  return (
    <Timeline
      events={events}
      addEvent={addTimelineEvent}
      isPending={isPending}
      inputId="registration-timeline-comment"
    />
  );
}
